import Button from "@client/controls/Button/component";
import Modal from "@client/controls/Modal/component";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import { type Purchase } from "../types";

export type MapProps = {
  alert: Purchase.Alert | null;
};

export type ActionProps = {
  onConfirm: () => void;
  onClose: () => void;
};
export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <Modal
      className="trial_confirm_modal"
      isAdminColor={false}
      width={400}
      isCentered
      hasBackdrop
      isVisible={!!props.alert}
      onClose={props.onClose}
    >
      <Modal.Header title={props.alert?.title} />
      <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: props.alert?.message ?? "" }} />
      </Modal.Body>
      <Modal.Footer>
        {props.alert?.canProceed ? (
          <>
            <Button className="btn-primary" onClick={props.onConfirm}>
              {i18n.continue}
            </Button>
            <Button className="btn-light" onClick={props.onClose}>
              {i18n.cancel}
            </Button>
          </>
        ) : (
          <Button className="btn-light" onClick={props.onClose}>
            {i18n.ok}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
